export default __webpack_public_path__ + "static/media/arrow-next.baa6ad1b.svg";